const shellPrefs = {
  title: "העדפות מסגרת",
  sidebarHover: "סיידבר בריחוף",
  sidebarWidth: "רוחב סיידבר",
  topbarVisible: "הצג סרגל עליון",
  topbarHover: "סרגל עליון בריחוף",
  tabbarVisible: "הצג סרגל לשוניות",
  trayVisible: "הצג מגש עבודה",
  speedDialVisible: "הצג חוגה מהירה",
  hoverHint: "מופיע בריחוף על הקצה",
  resetDefaults: "אפס לברירת מחדל",
} as const;
export default shellPrefs;
